import React from 'react';
import DatePicker from '~/components/date_picker';
const DateInput = (props) => {
    const { orgMetadataField, onChange, isRequired, hasRequiredError, val } = props;
    let formattedVal = val;
    if (val && val.length === 5) {
        const splitVal = val.split('-');
        formattedVal = `${Number(splitVal[1]) > 40 ? '19' : '20'}${splitVal[1]}-${splitVal[0]}`;
    }
    return (React.createElement("div", { className: 'form-input-group' },
        React.createElement("label", { className: 'input-label', htmlFor: orgMetadataField.name },
            orgMetadataField.name,
            " ",
            isRequired ? '*' : ''),
        React.createElement("div", { className: 'date-picker' },
            React.createElement(DatePicker, { id: orgMetadataField.name, name: orgMetadataField.name, "data-testid": `test-input-${orgMetadataField.name}`, isRequired: false, currentValue: formattedVal || '', setCurrentValue: onChange }),
            isRequired && hasRequiredError &&
                React.createElement("span", { className: 'required-error' }, "Required"))));
};
export default DateInput;
